import React from "react";
import styled from "styled-components";
import { Icon } from "react-icons-kit";
import { ic_dehaze } from "react-icons-kit/md/ic_dehaze";

const StyledToggle = styled.div`
  @media (min-width: 700px) {
    display: none;
  }
`;
const DrawerToggle = props => {
  return (
    <StyledToggle onClick={props.clicked}>
      <Icon
        style={{ fontSize: 30, color: "gray" }}
        size={30}
        icon={ic_dehaze}
      />
    </StyledToggle>
  );
};

export default DrawerToggle;



// WEBPACK FOOTER //
// ./src/components/Navgation/DrawerToggle/DrawerToggle.js